import { postData, fetchData } from "./apis";

const path = "/accounts";

export const getAdvanceTransactionApi = (value) => {
  let endPoint = `${path}/get-advance-trans`;
  return postData(endPoint, value);
};

export const getDebitorRcvWithDetailsApi = (value) => {
  let endPoint = `${path}/get-debitor-rcv-with-details`;
  return postData(endPoint, value);
};

export const getContraCodeApi = (value) => {
  let endPoint = `${path}/get-contra-code`;
  return postData(endPoint, value);
};

export const saveContraApi = (value) => {
  let endPoint = `${path}/save-contra`;
  return postData(endPoint, value);
};

export const deleteContraApi = (value) => {
  let endPoint = `${path}/delete-contra`;
  return postData(endPoint, value);
};

export const getContrasApi = (value) => {
  let endPoint = `${path}/get-contras`;
  return postData(endPoint, value);
};

export const getRecurringJournalsApi = (value) => {
  let endPoint = `${path}/get-recurring-journals`;
  return postData(endPoint, value);
};

export const saveRecurringJournalApi = (value) => {
  let endPoint = `${path}/save-recurring-journal`;
  return postData(endPoint, value);
};

export const deleteRecurringJournalApi = (value) => {
  let endPoint = `${path}/delete-recurring-journal`;
  return postData(endPoint, value);
};

export const saveAdvanceTranApi = (value) => {
  let endPoint = `${path}/save-advance-tran`;
  return postData(endPoint, value);
};

export const deleteAdvanceTranApi = (value) => {
  let endPoint = `${path}/delete-advance-tran`;
  return postData(endPoint, value);
};

export const getBranchTransactionApi = (value) => {
  let endPoint = `${path}/get-branch-trans`;
  return postData(endPoint, value);
};

export const getBranchAccsApi = (value) => {
  let endPoint = `${path}/get-branch-accs`;
  return postData(endPoint, value);
};

export const getBranchTransactionCodeApi = (value) => {
  let endPoint = `${path}/get-branch-tran-code`;
  return postData(endPoint, value);
};

export const SaveBranchTransactionApi = (value) => {
  let endPoint = `${path}/save-branch-tran`;
  return postData(endPoint, value);
};
export const DeleteBranchTransactionApi = (value) => {
  let endPoint = `${path}/delete-branch-tran`;
  return postData(endPoint, value);
};

export const saveCustomerCollectionApi = (value) => {
  let endPoint = `${path}/save-customer-collection`;
  return postData(endPoint, value);
};

export const getCollectionGroupsApi = (value) => {
  let endPoint = `${path}/get-collection-groups`;
  return postData(endPoint, value);
};

export const deleteAccountApi = (value) => {
  let endPoint = `${path}/delete-account`;
  return postData(endPoint, value);
};

export const saveAccountApi = (value) => {
  let endPoint = `${path}/save-account`;
  return postData(endPoint, value);
};
export const fetchparentaccountsApi = (value) => {
  let endPoint = `${path}/parents-by-type`;
  return postData(endPoint, value);
};

export const fetchOpeningBalanceOffsetCandidatesApi = (value) => {
  let endPoint = `${path}/opening-balance-offset-candidates`;
  return postData(endPoint, value);
};

export const fetchOpeningBalancesListApi = (value) => {
  let endPoint = `${path}/opening-balances-list`;
  return postData(endPoint, value);
};

export const saveOpeningBalancesApi = (value) => {
  let endPoint = `${path}/save-opening-balances`;
  return postData(endPoint, value);
};

export const checkSerialNumberApi = (value) => {
  let endPoint = `${path}/check-serial-number`;
  return postData(endPoint, value);
};

export const getItemBySearchApi = (value) => {
  let endPoint = `${path}/get-items-by-search`;
  return postData(endPoint, value);
};

export const getItemGroupsApi = (value) => {
  let endPoint = `${path}/get-item-groups`;
  return postData(endPoint, value);
};

export const getItemCategoriesApi = (value) => {
  let endPoint = `${path}/get-item-categories`;
  return postData(endPoint, value);
};
export const getGenericNamesApi = (value) => {
  let endPoint = `${path}/get-generic-names`;
  return postData(endPoint, value);
};
export const getBatchApi = (value) => {
  let endPoint = `${path}/get-batch`;
  return postData(endPoint, value);
};

export const getAlltBatchApi = (value) => {
  let endPoint = `${path}/get-all-batches`;
  return postData(endPoint, value);
};

export const getBatchAvailabilityApi = (value) => {
  let endPoint = `${path}/check-batch-availability`;
  return postData(endPoint, value);
};

export const deleteItemBatchApi = (value) => {
  let endPoint = `${path}/delete-batch`;
  return postData(endPoint, value);
};

export const saveCategorieManageApi = (value) => {
  let endPoint = `${path}/save-category-manage`;
  return postData(endPoint, value);
};
export const saveGenericNameManageApi = (
  value
) => {
  let endPoint =
    `${path}/save-generic-name-manage`;

  return postData(endPoint, value);
};

export const deleteGenericNameApi = (
  value
) => {
  let endPoint =
    `${path}/delete-generic-name`;

  return postData(endPoint, value);
};
export const saveBatchManageApi = (value) => {
  let endPoint = `${path}/save-batch-manage`;
  return postData(endPoint, value);
};

export const getItemApi = (value) => {
  let endPoint = `${path}/get-items`;
  return postData(endPoint, value);
};

export const deleteItemApi = (value) => {
  let endPoint = `${path}/delete-item`;
  return postData(endPoint, value);
};

export const getDuePurchaseVoucherApi = (value) => {
  let endPoint = `${path}/get-due-purchase-vouchers`;
  return postData(endPoint, value);
};

export const getVoucherSupplierBalanceApi = (value) => {
  let endPoint = `${path}/get-due-purchase-supplier-vouchers`;
  return postData(endPoint, value);
};
export const getDueSalesReturnVouchers = (value) => {
  let endPoint = `${path}/get-due-customer-returns`;
  return postData(endPoint, value);
};

export const getCreditorPayWithDetailsApi = (value) => {
  let endPoint = `${path}/get-creditor-pay-with-details`;
  return postData(endPoint, value);
};

export const getCreditorPaymentCodesApi = (value) => {
  let endPoint = `${path}/get-creditor-payment-code`;
  return postData(endPoint, value);
};

export const getSupplierWiseOutflowApi = (value) => {
  let endPoint = `${path}/get-supplier-wise-outflow`;
  return postData(endPoint, value);
};

export const getSupplierOutflowMatrixApi = (value) => {
  let endPoint = `${path}/get-supplier-outflow-matrix`;
  return postData(endPoint, value);
};

export const getOutstandingPdcReportApi = (value) => {
  let endPoint = `${path}/get-outstanding-pdc-report`;
  return postData(endPoint, value);
};

export const saveCreditorPaymentApi = (value) => {
  let endPoint = `${path}/save-creditor-payment`;
  return postData(endPoint, value);
};

export const deleteCreditorPaymentApi = (value) => {
  let endPoint = `${path}/delete-creditor-payment`;
  return postData(endPoint, value);
};

export const getDueEmisApi = (value) => {
  let endPoint = `${path}/get-due-emis`;
  return postData(endPoint, value);
};

export const getDueSalesVoucherApi = (value) => {
  let endPoint = `${path}/get-due-sales-vouchers`;
  return postData(endPoint, value);
};
 
export const getDuePurchaseReturns = (value) => {
  let endPoint = `${path}/get-due-purchase-returns`;
  return postData(endPoint, value);
};
 
export const getDebitorReciptCodeApi = (value) => {
  let endPoint = `${path}/get-debitor-receipt-code`;
  return postData(endPoint, value);
};

export const saveDebitorReciptApi = (value) => {
  let endPoint = `${path}/save-debitor-receipt`;
  return postData(endPoint, value);
};

export const deleteDebitorReciptApi = (value) => {
  let endPoint = `${path}/delete-debitor-receipt`;
  return postData(endPoint, value);
};

export const getExpenseWithDetailsApi = (value) => {
  let endPoint = `${path}/get-expense-with-details`;
  return postData(endPoint, value);
};

export const getJournalWithDetailsApi = (value) => {
  let endPoint = `${path}/get-journal-with-details`;
  return postData(endPoint, value);
};

export const getJournalCodeApi = (value) => {
  let endPoint = `${path}/get-journal-code`;
  return postData(endPoint, value);
};

export const saveJournalApi = (value) => {
  let endPoint = `${path}/save-journal`;
  return postData(endPoint, value);
};

export const deleteJournalApi = (value) => {
  let endPoint = `${path}/delete-journal`;
  return postData(endPoint, value);
};

export const getExpenseCodeApi = (value) => {
  let endPoint = `${path}/get-expense-code`;
  return postData(endPoint, value);
};

export const saveExpenseApi = (value) => {
  let endPoint = `${path}/save-expense`;
  return postData(endPoint, value);
};

export const deleteExpenseApi = (value) => {
  let endPoint = `${path}/delete-expense`;
  return postData(endPoint, value);
};

export const getRecognitionWithDetailsApi = (value) => {
  let endPoint = `${path}/get-recognition-with-details`;
  return postData(endPoint, value);
};

export const saveRecognitionApi = (value) => {
  let endPoint = `${path}/save-recognition`;
  return postData(endPoint, value);
};

export const approveExpenseRecognitionApi = (value) => {
  let endPoint = `${path}/approve-expense-recognition`;
  return postData(endPoint, value);
};

export const deleteRecognitionApi = (value) => {
  let endPoint = `${path}/delete-recognition`;
  return postData(endPoint, value);
};

export const getIncomeWithDetailsApi = (value) => {
  let endPoint = `${path}/get-income-with-details`;
  return postData(endPoint, value);
};

export const getIncomeCodeApi = (value) => {
  let endPoint = `${path}/get-income-code`;
  return postData(endPoint, value);
};

export const saveIncomeApi = (value) => {
  let endPoint = `${path}/save-income`;
  return postData(endPoint, value);
};

export const deleteIncomeApi = (value) => {
  let endPoint = `${path}/delete-income`;
  return postData(endPoint, value);
};

export const getAccountCodeApi = (value) => {
  let endPoint = `${path}/get-acc-code`;
  return postData(endPoint, value);
};


export const saveCollectionGroupApi = (value) => {
  let endPoint = `${path}/save-collection-group`;
  return postData(endPoint, value);
};

export const deleteCollectionGroupApi = (value) => {
  let endPoint = `${path}/delete-collection-group`;
  return postData(endPoint, value);
};

export const getAccountBalanceApi = (value) => {
  let endPoint = `${path}/get-accounts-balance`;
  return postData(endPoint, value);
};

export const getSundryCreditorBalanceApi = (value) => {
  let endPoint = `${path}/get-sundry-creditor-balance`;
  return postData(endPoint, value);
};

export const getSundryDebitorBalanceApi = (value) => {
  let endPoint = `${path}/get-sundry-debitor-balance`;
  return postData(endPoint, value);
};
export const getCustomerAgeingApi = (value) => {
  return postData(`${path}/get-customer-ageing`, value);
};

export const getVendorAgeingApi = (value) => {
  return postData(`${path}/get-vendor-ageing`, value);
};
export const getUniversalLedgerApi = (value) => {
  return postData(`${path}/get-universal-account-ledger`, value);
};

export const getSundryDebitorInsuranceBalanceApi = (value) => {
  let endPoint = `${path}/get-sundry-debitor-insurancebalance`;
  return postData(endPoint, value);
};

export const saveMultipleAccountsApi = (value) => {
  let endPoint = `${path}/save-multiple-accounts`;
  return postData(endPoint, value);
};

export const getExceltemplateApi = () => {
  let endPoint = `${path}/template`;
  return fetchData(endPoint);
};

export const deleteLocationApi = (locationDetails) => {
  let endPoint = `${path}/delete-location`;
  return postData(endPoint, locationDetails);
};

export const getChequesApi = (value) => {
  let endPoint = `${path}/get-cheques`;
  return postData(endPoint, value);
};

export const getUpdateChequeApi = (value) => {
  let endPoint = `${path}/update-cheque`;
  return postData(endPoint, value);
};
export const deleteChequeApi = (value) => {
  let endPoint = `${path}/delete-cheque`;
  return postData(endPoint, value);
};

export const getIdByChequeApi = (value) => {
  let endPoint = `${path}/get-cheque-by-id`;
  return postData(endPoint, value);
};

export const getUpdateChequeExpectedBankApi = (value) => {
  let endPoint = `${path}/update-cheque-expected-bank`;
  return postData(endPoint, value);
};

export const getPendingPurchaseOrderApi = (value) => {
  let endPoint = `${path}/get-pendimg-purchase-order-vouchers`;
  return postData(endPoint, value);
};

export const getJournalCodesApi = (value) => {
  let endPoint = `${path}/get-journalCodes`;
  return postData(endPoint, value);
};